import EventBus from '@mvps-genesis/event-bus';
import {BopisController} from 'custom-extensions/bopis';
import {LitElement, html} from 'lit';
import styles from './MyStoreToggle.component.scss?as=stylesheet';

export default class MyStoreToggle extends LitElement {

	/**
	 * Define stylesheets
	 * @see https://lit.dev/docs/components/styles/
	 * @static
	 */
	static get styles () {
		return [styles];
	}

	/**
	 * Define reflector properties
	 * @see https://lit.dev/docs/components/properties/
	 * @static
	 */
	static get properties () {
		return {
			identifier: {
				type: String
			},
			store: {
				type: Object
			}
		};
	};

	/**
	 * @constructor
	 */
	constructor () {
		super();

		this.controller = BopisController;
		this.identifier = 0;
		this.store = {};
	}

	/**
	 * Invoked when a component is added to the document's DOM.
	 * @see https://lit.dev/docs/components/lifecycle/#connectedcallback
	 * @static
	 */
	connectedCallback () {
		super.connectedCallback();
		this.bopisStoreUnsubscribe = this.controller.store.subscribe(() => this.requestUpdate());
	}

	/**
	 * Invoked when a component is removed from the document's DOM.
	 * @see https://lit.dev/docs/components/lifecycle/#disconnectedcallback
	 * @static
	 */
	disconnectedCallback () {
		this.bopisStoreUnsubscribe();
		super.disconnectedCallback();
	}

	get isMyStore () {
		const identifier = this.identifier || this.store.identifier;
		return identifier?.toString() === this.controller?.store?.state?.myStore?.identifier?.toString();
	}

	/**
	 * Render the "Set As My Store" Toggle to set the store as your "My Store"
	 * @return {html}
	 */
	render () {
		return html`
			<label class="g-form-toggle">
				<input class="g-form-checkbox__input" type="checkbox" value="1" .checked="${this.isMyStore}" @change="${(e) => this.setLocationAsMyStore(e)}">
				<span class="g-form-checkbox__caption">Select this Store</span>
			</label>
		`;
	}

	/**
	 * Sets the current location as "My Store"
	 */
	async setLocationAsMyStore (e) {
		const checked = e.target?.checked;

		let location = {};

		if (checked) {
			location = this.identifier ? await this.controller?.api.singleLocationLookup(this.identifier) : this.store;
		}

		this.controller.setMyStore(location);

		EventBus.dispatchEvent('MVPS:myStoreChanged', {
			location: location
		});
	}
};

customElements.define('x-my-store-toggle', MyStoreToggle);
